import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const useNavigationPrompt = (hasChanges: boolean) => {
  const { t } = useTranslation('common');
  const history = useHistory();

  useEffect(() => {
    /**
     * Show default prompt when refreshing / closing tabs
     */
    const showUnload = (e: BeforeUnloadEvent) => {
      if (hasChanges) {
        e.preventDefault();
        e.returnValue = '';
      }

      return '';
    };

    let unblock: () => void;

    if (hasChanges) {
      unblock = history.block(t('navigation_prompt.unfinished_form_prompt') as string);
    }

    window.addEventListener('beforeunload', showUnload);

    return () => {
      window.removeEventListener('beforeunload', showUnload);
      unblock?.();
    };
  }, [hasChanges]);
};

export default useNavigationPrompt;
